import React, { useEffect, useState } from 'react'

import { useModals } from '../PurchaseFlow/NewCheckoutWrapper/providers/ModalsProvider'

import { sort } from '../../utilities/helpers'

import Stack from 'react-bootstrap/Stack'
import Card from 'react-bootstrap/Card'

import { BackButton } from '../BackButton'
import { PackageEventList } from '../PackageEventList'
import { Event } from '../PurchaseFlow/components/Event'
import PackagePassTicketsView from './PackagePassTicketsView'

export default function PackageDetailsWrapper({
  eventPackage,
  events,
  orderId,
  order,
  accessPasses,
}) {
  const { openModal } = useModals()

  const [event, setEvent] = useState()

  useEffect(() => {
    if (eventPackage) {
      const event = sort(eventPackage?.events)[0]
      setEvent(event)
    }
  }, [eventPackage])

  return (
    <>
      <section className="spacer-xs">
        <div className="d-flex-column flex-lg-row gap-5">
          <div className="tablet-desktop-only">
            <BackButton />
          </div>
          <Stack gap={4}>
            <Event
              eventPackage={eventPackage}
              event={event}
              openModal={openModal}
            />
            {accessPasses?.length > 0 ? (
              <PackagePassTicketsView
                accessPasses={accessPasses}
                packageEvents={events}
                eventPackage={eventPackage}
                orderId={orderId}
                order={order}
              />
            ) : (
              <Card body className="card-xl card-xl--dark">
                <Card.Title>Events & Tickets</Card.Title>
                <PackageEventList
                  events={events}
                  linkTo={`/event-details/${orderId}`}
                />
              </Card>
            )}
          </Stack>
        </div>
      </section>
    </>
  )
}
